var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-edit-dialog', _vm._g({
    attrs: {
      "return-value": _vm.form.repliedAt,
      "large": "",
      "cancel-text": "취소",
      "save-text": "저장"
    },
    on: {
      "update:returnValue": function ($event) {
        return _vm.$set(_vm.form, "repliedAt", $event);
      },
      "update:return-value": function ($event) {
        return _vm.$set(_vm.form, "repliedAt", $event);
      },
      "open": _vm.sync
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function () {
        return [_c('v-sheet', {
          staticClass: "mx-n3",
          attrs: {
            "width": "240"
          }
        }, [_c('v-datetime-field', {
          attrs: {
            "hide-details": "",
            "clearable": "",
            "label": ""
          },
          model: {
            value: _vm.form.repliedAt,
            callback: function ($$v) {
              _vm.$set(_vm.form, "repliedAt", $$v);
            },
            expression: "form.repliedAt"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, {
    save: _vm.save
  }), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }